import qs from "qs";
import {apiVoissa} from "../../libs/api";
import _ from "lodash";

export const hydrateRooms = (rooms, currentUserId) => {
    rooms = Array.isArray(rooms) ? rooms : [];
    return rooms
        .filter(room => !room.hasError)
        .sort(function (a, b) {
            let dateA = new Date(a.lastMessageCreatedAt), dateB = new Date(b.lastMessageCreatedAt);
            return dateB - dateA
        })
        .map(room => {
            let users = Array.isArray(room.users) ? room.users : [];
            let usersManagement = Array.isArray(room.usersManagement) ? room.usersManagement : [];
            room.participantsWithoutCurrent = users.filter(user => user._id !== currentUserId);
            room.currentUserIsOwner = _.get(room,"owner._id") === currentUserId;
            room.isLocked = !!usersManagement.find(user => user.locked);
            room.hasUserOnline = !room.isLocked && !!users.find(user => (user.online && user._id !== currentUserId));
            room.currentUserIsArchived = !!usersManagement.find(user => (user.archived && user.owner === currentUserId));
            room.currentUserIsLocker = !!usersManagement.find(user => (user.locked && user.owner === currentUserId));
            room.isReadByCurrentUser = !!_.get(usersManagement.find(user => user.owner === currentUserId), 'read');
            room.isDeletedByCurrentUser = !!_.get(usersManagement.find(user => user.owner === currentUserId), 'isDeleted');
            room.currentUserId = currentUserId;

            return room;
        });
}

export const fetchRooms = async (currentUserId = null, query = {}, config={}) => {
    let res = await apiVoissa.get(`/rooms?${qs.stringify(query)}`, config);
    if(Array.isArray(res.data) && res.data.length){
        res.data = hydrateRooms(res.data, currentUserId);
    }
    return res;
};



export const fetchRoom = async (currentUserId = null,roomId = null, query = {}, config={}) => {
    let res = await apiVoissa.get(`/rooms/${roomId}?${qs.stringify(query)}`, config);
    if(res){
        let data = hydrateRooms([res], currentUserId);
        res = data.length ? data[0] : res;
    }
    return res;
};
export const createRoom = (data = {}, config={}) => apiVoissa.post(`/rooms`, data, config);
export const updateRoom = (roomId = null, data = {}, config={}) => apiVoissa.patch(`/rooms/${roomId}`, data, config);
export const joinRoom = (roomId = null, joinRoom = {}, config={}) => apiVoissa.post(`/rooms/${roomId}/join-member`, joinRoom, config);
export const leaveRoom = (roomId = null, leaveRoom = {}, config={}) => apiVoissa.post(`/rooms/${roomId}/leave-member`, leaveRoom, config);
export const lockRoom = (roomId = null, lockRoom = {}, config={}) => apiVoissa.patch(`/rooms/${roomId}/lock-room`, lockRoom, config);
export const readRoom = (roomId = null, readRoom = {}, config={}) => apiVoissa.patch(`/rooms/${roomId}/read-room`, readRoom, config);
export const archivedRoom = (roomId = null, archivedRoom = {}, config={}) => apiVoissa.patch(`/rooms/${roomId}/archived-room`, archivedRoom, config);
export const removeRoomByUser = (roomId = null, config={}) => apiVoissa.delete(`/rooms/${roomId}`, config);


export const fetchRoomMessages = (roomId = null, query = {}, config = {}) => apiVoissa.get(`/rooms/${roomId}/messages?${qs.stringify(query)}`, config);
export const fetchRoomMedias = (roomId = null, query = {}, config = {}) => apiVoissa.get(`/rooms/${roomId}/medias?${qs.stringify(query)}`, config);


export const fetchRoomMessage = (roomId = null, messageId = null, query = {}, config) => apiVoissa.get(`/rooms/${roomId}/messages/${messageId}?${qs.stringify(query)}`);
export const createRoomMessage = (roomId = null, data = {}, config) => apiVoissa.post(`/rooms/${roomId}/messages`, data);
export const createRoomMessageMedia = (roomId = null, data = {}, config) => apiVoissa.post(`/rooms/${roomId}/messages-medias`, data);
export const updateRoomMessage = (roomId = null, messageId = null, data = {}, config) => apiVoissa.patch(`/rooms/${roomId}/messages/${messageId}`, data);
export const deleteRoomMessage = (roomId = null, messageId = null, config) => apiVoissa.delete(`/rooms/${roomId}/messages/${messageId}`);



export const ROOMS_KEY = `rooms`;
export const ROOM_KEY = `room`;
export const ROOM_MESSAGES_KEY = `room-messages`;
export const ROOM_MEDIAS_KEY = `room-medias`;

export const initFilter = {
    limit: 15,
    sort: "-lastMessageCreatedAt",
    archived : false
}